var formatMoney = require('../General/Helper').formatMoney;
var OrderDeliveryOption = require('../General/DeliveryOption').DeliveryOption;
import { AbconetApi } from '../General/AbconetApi';
import $ from "jquery";
import { isNullOrUndefined } from 'util';
import moment from "moment";
import ReactTooltip from 'react-tooltip'
import ReactModal from "react-modal";

import { getStockInfo } from "./CartFunctions";

import { ProductApprovedStockListLogo } from '../Product/ProductApprovedStockListLogo';
var CartOrderApproval = require('./CartOrderApproval').CartOrderApproval;
import { renderToString } from 'react-dom/server'
import { QuantitySelector } from "../General/QuantitySelector";
import { ItemReplacementSelector } from "../General/ItemReplacementSelector";


class CartLineAlternative extends React.Component {

    doReplacement(ev) {
        //ev.preventDefault();
        this.props.updateStock(this.props.stock.stockcode);
    }

    doReplacePartial(remainingQuantity, partialQuantity) {

        this.props.replacePartial(this.props.stock.stockcode, remainingQuantity, partialQuantity);
    }

    render() {     
        var stock = this.props.stock;
        var unitPrice = formatMoney(stock.bestPrice);

        var productImage = <a href={stock.url}><img src={stock.imageFileName} className="product-image" style={{ "width": "100%" }}/></a>;


        if (!this.props.cart.canEdit && !this.props.cart.canApprove) {
            return null;
        }
        var btnClass = 'changes';
        var disabled = false;

        if (this.props.isSaving) {
            disabled = true;        
        }

        if (this.props.isSaving && this.props.stock.stockcode == this.props.selectedItem) {
            btnClass = 'saving';
        }

        var stockInfo = getStockInfo(this.props.cart, this.props.stock, this.props.quantity, this.props.stockLevel);

        var partialQuantity = this.props.quantity - this.props.remainingQuantity ;

        var stockAvailabilityElement = null;

        if (stockInfo && stockInfo.type != 'in-stock') {
            return null;
        }

        if (this.props.hidePrices) {
            unitPrice = "";
        }

        return <div className={"item"} >
                    <div className="row">
                        <div className="col-1 d-none d-lg-block">
                            {productImage}
                        </div>
                        <div className="col-9 col-lg-5">
                            <p className="description">{stock.name}</p>
                        </div>
                        <div className="col-3 col-lg-2 text-right">
                            {unitPrice}
                        </div>
  
                <div className="col-2 col-lg-2 text-right">
                    <span className="add-to-cart-container">
                        <ItemReplacementSelector disabled={disabled} btnClass={btnClass} replaceAll={this.doReplacement.bind(this)} replacePartial={this.doReplacePartial.bind(this, this.props.remainingQuantity, partialQuantity)} remainingQuantity={this.props.remainingQuantity} partialQuantity={partialQuantity} />
                    </span>
                </div>
            </div>
                   <div className="row">
                       <div className="col-12">
                    <span className="stockcode">Code: {stock.stockcode}</span>
                    {stockAvailabilityElement}
                       </div>
                   </div>
            </div>;
    }
}

export class CartLine extends React.Component {

    renderIsOnAsl(row) {
        if (isNullOrUndefined(this.props.cart)) {
            return;
        }

        if (this.props.cart) {
            return <ProductApprovedStockListLogo product={row.product} />
        }

        return;
    }

    renderInStock(row) {
        var stockInfo = getStockInfo(this.props.cart, row.product, row.quantity, row.stockLevel);

        if (stockInfo && stockInfo.type != 'in-stock') {
            return <span className={"stock-availability " + stockInfo.type}>{stockInfo.text}</span>;
        }

        return null;
    }

    renderRechargeableSection() {
        var row = this.props.lineData;
        if (!this.props.cart.allowRechargeableSetting) {
            return;
        }

        if (this.props.isItemReplacement) {
            return null;
        }

        return <div className="rechargeable-field">
                   <span>
                <input type="checkbox" className="checkbox mt-1" id={'rechargeable-' + row.stockcode} onClick={this.updateRechargeable.bind(this)} checked={row.rechargeable} disabled={!this.props.cart.canEdit || !this.props.cart.canEditRechargeable} />
                   </span>
                   <label htmlFor={'rechargeable-' + row.stockcode}>
                       Rechargeable
                   </label>
               </div>
    }

    handleUpdateQuantity(ev) {
        this.props.updateQuantity(this.props.lineData, ev.target.value);
    }

    handleRemoveItem(ev) {
        ev.preventDefault();

       
        
        this.props.removeItem(this.props.lineData);
    }

    updateRechargeable(ev) {
        ev.preventDefault();
        this.props.updateRechargeable(this.props.lineData);
    }

    updateDontReplaceCollection() {

        var item = {
            stockCode: this.props.lineData.stockcode
        }
       
        this.props.updateDontReplaceCollection(item);
        
    }

    handleUpdateStockcode(newStockcode) {
        dataLayer.push({
            event: 'select_alternative',
            oldStockcode: this.props.lineData.stockcode,
            newStockcode: newStockcode,
            quantity: this.props.lineData.quantity,
            value: `Replace ${this.props.lineData.quantity} x ${this.props.lineData.stockcode} with ${newStockcode}`
        })

        this.props.updateStockcode(this.props.lineData, this.props.lineData.stockcode, newStockcode);
                
    }

    handleReplacePartial(newStockcode, remainingQuantity, partialQuantity) {
        this.props.replacePartial(this.props.lineData, this.props.lineData.stockcode, newStockcode, remainingQuantity, partialQuantity);
    }

    render() {
        var row = this.props.lineData;

        var cart = this.props.cart;

        var unitPrice = formatMoney(row.unitPrice);
        var lineTotal = formatMoney(row.lineTotal);

        var stockLocationInfo = getStockInfo(cart, row.product, row.quantity, row.stockLevel);
        var learnMoreLabel = null;

        if (this.props.isItemReplacement) {
            var hasDontReplaceStockCode = this.props.dontReplaceCollection.filter(x => x.stockCode == row.stockcode);

            if (hasDontReplaceStockCode.length != 0) {
                return null;
            }
         
            if (stockLocationInfo && !stockLocationInfo.willTriggerBackorder) {
                return null;
            }

            if (row.product.alternativeProductCollection.length <= 0) {
                return null;
            }            
        } else {
            if (this.props.member && this.props.member.abcoUser && this.props.member.abcoUser.shippingPolicyId != 5) {
                learnMoreLabel = <div style={{ "fontSize": "12px", "backgroundColor": "#ffffff", "borderColor": "#ffffff" }} className="description warning-block">
                                     <svg style={{ "marginRight": "5px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                         <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                         <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                     </svg>
                                     Delivery charges may apply. &nbsp;
                                     <a href="/shipping" target="_blank">Learn more</a>
                                 </div>
                {
                    (stockLocationInfo && stockLocationInfo.issue != null) && <div style={{ "fontSize": "12px", "backgroundColor": "#ffffff", "borderColor": "#ffffff" }} className="description error-block" >
                                                                                  <svg style={{ "marginRight": "5px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                                                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                                                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                                                                  </svg>
                                                                                  Delivery charges may apply. &nbsp;
                                                                                  <a href="/shipping" target="_blank">Learn more</a>
                                                                              </div>
                }
                <ReactTooltip />
            }
            
        }

        if (this.props.hidePrices) {
            unitPrice = "";
            lineTotal = "";
        }
        var productImage;

        if (row.product) {
            productImage =
                <a href={row.product.url}><img src={row.product.imageFileName} className="product-image" style={{"width":"100%"}} /></a>;
        }

        var extraClass = "";
        var altStock;
        var hasAlternativeItems = false;

        if (stockLocationInfo && stockLocationInfo.willTriggerBackorder) {
            var isDiscontinuedItem = stockLocationInfo.type == "low-stock";
            extraClass += ' will-trigger-backorder';

            if (row.product.alternativeProductCollection.length > 0 && (this.props.isItemReplacement) && this.props.disableItemReplacement == false) {
                altStock = <div className="alt-stock open" style={{ marginTop: '40px' }}>                    
                    {row.product.alternativeProductCollection.map(
                        altProduct => {
                            var item = <CartLineAlternative
                                cart={cart} stock={altProduct}
                                isSaving={this.props.isSaving}
                                updateStock={this.handleUpdateStockcode.bind(this)}
                                replacePartial={this.handleReplacePartial.bind(this)}
                                currentLocation={cart.supplyLocation}
                                quantity={row.quantity}
                                hidePrices={this.props.hidePrices}
                                selectedItem={this.props.selectedItem}
                                member={this.props.member}
                                remainingQuantity={stockLocationInfo.locationQuantity}
                            />;                          

                            if (renderToString(item) !== null && renderToString(item) != "") {
                                hasAlternativeItems = true;
                                return item;
                            }
                        })}
                         
                    {!isDiscontinuedItem && (
                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                            <span className="pr-2">
                                <input defaultChecked={false} type="checkbox" id={'dontReplace-' + row.stockcode} onChange={this.updateDontReplaceCollection.bind(this)} />
                            </span>
                            <strong>
                                <label htmlFor={'dontReplace-' + row.stockcode}>
                                Don't replace this item
                                </label>
                            </strong>
                        </div>
                    )}

                    
                </div>;

                if (!hasAlternativeItems) {             
                     this.updateDontReplaceCollection();
                }
            }     
            
        }
      

        if (stockLocationInfo && stockLocationInfo.issue != null) {
            extraClass += ' will-trigger-error';
        }
        //<input className="form-control add-item" type="number" onChange={this.handleUpdateQuantity.bind(this)} value={row.quantity} min="0" readOnly={!cart.canEdit || cart.hasCompleted} />

        var quantitySelector = <QuantitySelector cart={this.props.cart}
            item={row.product}
            onChange={this.handleUpdateQuantity.bind(this)}
            value={row.quantity}
            unit={row.product != null ? row.product.unit ? row.product.unit : "Unit" : "Unit"}
            unitPlural={row.product != null ? row.product.unitPlural ? row.product.unitPlural : "Units" : "Units"}
            packQty={row.product != null ? row.product.packQty : null} palletQty={row.product != null ? row.product.palletQty : null}
            layerQty={row.product != null ? row.product.layerQty : null}
        />;

        if (!cart.canEdit || cart.hasCompleted) {
            quantitySelector = <span className="quantity">{row.quantity}</span>;
        }

        return (
            <div className={"item" + extraClass} key={row.stockcode}>
                {learnMoreLabel}



                <div className="row">
                    <div className="col-1 d-none d-lg-block">
                        {productImage}
                    </div>
                    <div className="col-7 col-lg-5">
                        <p className="description">{row.description}</p>
                    </div>
                    <div className="col-2 col-lg-2 text-right">
                        <span className="add-to-cart-container">
                            {quantitySelector}
                        </span>
                    </div>
                    <div className="col-3 col-lg-2 text-right">
                        {unitPrice}
                    </div>
                    <div className="d-none d-lg-block col-2 text-right cart-total">
                        {lineTotal}
                        {cart.canEdit && <div className="d-inline-block remove-block"><a href="#" onClick={this.handleRemoveItem.bind(this)}><i className="icon icon-close px-3 lead"></i></a></div>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <span className="stockcode">Code: {row.stockcode}</span>
                        {this.renderRechargeableSection(row)}
                        {this.renderInStock(row)}
                        {this.renderIsOnAsl(row)}
                        <a href="#" className="d-lg-none btn btn-outline-primary float-right" onClick={this.handleRemoveItem.bind(this)}>Delete</a>
                    </div>
                    {altStock}
                </div>
            </div>
        );
    }
}


function clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}

export class CartDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cart: this.props.initialCart,
            isApproving: false,
            isCheckingOut: false,
            isSaving: false,
            isSendingForEdit: false,
            orderStatus: this.props.initialCart.pickupLocation != null && this.props.initialCart.pickupLocation != undefined ? 'Ready for pick-up' : 'Dispatched',
            purchaseOrderNumber: this.props.initialCart.purchaseOrderNumber,
            rejectModalOpen: false,
            isRejectSaving: false,
            rejectReason: "",
            selectedItem: 0
        }
    }

    canApprove() {
        return true;
    }


    updateStockcode(row, oldStockcode, newStockcode) {
        this.setState({ selectedItem: newStockcode });

        var cart = this.state.cart;
        var existingStockcodeIndex = cart.lines.findIndex((x) => x.stockcode == newStockcode);

        for (var i = 0; i < cart.lines.length; i++) {
            if (cart.lines[i].stockcode === oldStockcode) {
                if (existingStockcodeIndex >= 0) {
                    cart.lines[existingStockcodeIndex].quantity += cart.lines[i].quantity;
                    cart.lines[i].quantity = 0;
                } else {
                    cart.lines[i].stockcode = newStockcode;            
                }

                

                break;
            }
        }       


        this.setState({ cart: cart }, this.updateServerWithStateTimeout());

    }

    addNewItem(row, oldStockcode, newStockcode, remainingQuantity, partialQuantity) {

        AbconetApi.post(`/api/cart/stockcode/${newStockcode}`, partialQuantity).then(cart => {
            $(document).trigger("CartUpdated", cart);

            this.setState({ cart: cart }, () => { this.updateReplacedItem(oldStockcode, newStockcode, remainingQuantity); });
        });
    }

    updateReplacedItem(oldStockcode, newStockcode, remainingQuantity) {
        var cart = this.state.cart;
        var existingStockcodeIndex = cart.lines.findIndex((x) => x.stockcode == newStockcode);

        if (existingStockcodeIndex >= 0) {
            for (var i = 0; i < cart.lines.length; i++) {
                if (cart.lines[i].stockcode === oldStockcode) {
                    cart.lines[i].quantity = remainingQuantity;
                    break;
                }
            }
            this.setState({ cart: cart }, this.updateServerWithStateTimeout());
        }
    }

    replacePartial(row, oldStockcode, newStockcode, remainingQuantity, partialQuantity) {   
        this.setState({ selectedItem: newStockcode, isSaving: true });

        var cart = this.state.cart;
        var existingStockcodeIndex = cart.lines.findIndex((x) => x.stockcode == newStockcode);

        if (existingStockcodeIndex < 0) {
           return this.addNewItem(row, oldStockcode, newStockcode, remainingQuantity, partialQuantity);
        } else {
            for (var i = 0; i < cart.lines.length; i++) {

                if (cart.lines[i].stockcode === oldStockcode) {
                    if (existingStockcodeIndex >= 0) {
                        cart.lines[existingStockcodeIndex].quantity += partialQuantity;
                        cart.lines[i].quantity = remainingQuantity;
                    } else {
                        cart.lines[i].quantity = remainingQuantity;
                    }

                    break;
                }
            }

            this.setState({ cart: cart }, this.updateServerWithStateTimeout());
        }   
    }

    updateDontReplaceCollection(item) {
        this.props.updateDontReplaceCollection(item);
    }

    componentDidUpdate(prevProps, prevState) {       
        if (prevState.cart != this.state.cart) {
            if (this.props.isItemReplacement) {
                this.props.updateCartOfCheckout(this.state.cart);             
            }
        }
    }

    updateQuantity(row, quantity) {
        var cart = this.state.cart;
        for (var i = 0; i < cart.lines.length; i++) {
            if (cart.lines[i].stockcode === row.stockcode) {
                cart.lines[i].quantity = quantity;

            }
        }

        if (quantity.length >= 0 || quantity >= 0) {
            this.setState({ cart: cart }, this.updateServerWithStateTimeout());
        } else {
            this.setState({ cart: cart, abortController: null });
        }

    }



    updateRechargeable(row) {
        var currentCart = this.state.cart;
        var index = currentCart.lines.findIndex(function (obj) {
            return obj['stockcode'] === row.stockcode;
        });

        currentCart.lines[index].rechargeable = !currentCart.lines[index].rechargeable;

        this.setState({
            cart: currentCart
        }, this.updateServerWithStateTimeout());
    }

    updateServerWithStateTimeout() {
        
        clearTimeout(this.state.updateServerTimeout);

        var timeout = setTimeout(() => {

            this.updateServerWithState();
        },
            100);
        this.setState({ updateServerTimeout: timeout });
    }

    updateServerWithState() {
        this.setState({ isSaving: true });
        if (this.state.abortController != null) {
            this.state.abortController.abort();
        }

        var abortController = new AbortController();
        this.setState({ abortController: abortController });
        AbconetApi.post('/api/cart/', this.state.cart, abortController.signal).then((cart) => {
            if (cart) {
                this.setState({ cart: cart, abortController: null, isSaving: false });
                $(document).trigger("CartUpdated", cart);
            } else {
                this.setState({ abortController: null, isSaving: false });
            }
           
            
        }).catch(function () {
        });;

        
    }

    sendForEdit() {
        this.setState({ isSendingForEdit: true });
        AbconetApi.post(`/api/cart/${this.state.cart.id}/setedit`).then((cart) => {
            this.setState({ cart: cart, isSendingForEdit: false });
            $(document).trigger("CartUpdated", cart);
            window.location.reload();
        });
    }

    approve() {
        this.setState({ isApproving: true });
        AbconetApi
            .post(`/api/cart/${this.state.cart.id}/approve`)
            .then((data) => {
                if (data.cart.hasCompleted) {

                    var cartItems = data.cart.lines.map((item, index) => {
                        return {
                            'item_name': item.product.name,       // Name or ID is required.
                            'item_id': item.stockcode,
                            'price': item.unitPrice,
                            'quantity': item.quantity,
                            'index': index
                        }
                    });

                    function generateUniqueTransactionId() {
                        const timestamp = Date.now();
                        const randomPart = Math.floor(Math.random() * 10000); // Generate a random number between 0 and 999999
                        const transactionId = `T_${timestamp}_${randomPart}`;
                        return transactionId;
                    }
                    let generatedUniqueID = generateUniqueTransactionId();

                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: "purchase",
                        ecommerce: {
                            transaction_id: generatedUniqueID,
                            value: data.cart.totalPrice,
                            currency: "AUD",
                            items: cartItems
                        }
                    })
                    window.location = '/cart/' + data.cart.id + '?msg=successOrder';
                }
                else if (data.id) {
                    window.location = '/orders/' + data.id + '?msg=successOrder';
                } else {
                    window.location = '/cart/checkout/';
                }
            });
    }

    checkout() {
        this.setState({ isCheckingOut: true });

        AbconetApi.post(`/api/cart/${this.state.cart.id}/setascurrent`).then(() => {

            window.location = '/cart/checkout/';
        });
    }

    setDeliveryOption(deliveryOption) { 

        var currentCart = this.state.cart;
        var orderStatus = '';
        if (deliveryOption.deliveryType == "PICK-UP") { 
            orderStatus = 'Ready for pick-up';
        } else {            
            orderStatus = 'Dispatched';
        }

        currentCart.pickupLocation = deliveryOption.pickupLocation;
        currentCart.address = deliveryOption.address;

        this.setState({
            cart: currentCart,
            orderStatus: orderStatus
        },
            this.updateServerWithState());
    }

    removeItem(row) {
        var currentCart = this.state.cart;
        var index = currentCart.lines.findIndex(function (obj) {
            return obj['stockcode'] === row.stockcode;
        });

        currentCart.lines[index].quantity = 0;

        this.setState({
            cart: currentCart
        }, this.updateServerWithState());
    }
    closeRejectModal() {

        this.setState({
            rejectModalOpen: false
        });
    }

    openRejectModal() {
        this.setState({
            rejectModalOpen: true
        });
    }

    rejectOrder() {
        this.setState({
            isRejectSaving: true
        });

        AbconetApi.post(`/api/cart/${this.state.cart.id}/reject`, this.state.rejectReason).then(template => {
            location.reload();

        });
    }
   
    renderNoItemMessage() {
        if (this.state.cart.lines.length <= 0) {
            return (<div className="alert alert-info">No items in your cart.</div>);
        }
    }

    renderCompleteMessage() {
        if (this.state.cart.hasCompleted) {
            return (<div className="alert alert-info">Your cart has been submitted and is awaiting processing.</div>);
        }
    }

    renderForApprovalMessage() {
        if (!isNullOrUndefined(this.state.cart.orderApproval)) {
            return <CartOrderApproval cart={this.state.cart} />;
        }
    }

    renderRechargeableHeader() {
        if (!this.state.cart.allowRechargeableSetting) {
            return;
        }

        return <div className="col-2 col-lg-1 col-hd">R
        </div>
    }

    renderHeader() {
        if (this.state.cart.lines.length > 0) {
            var priceHeader = "Price";
            var totalHeader = "Total";
            if (this.props.hidePrices) {
                priceHeader = "";
                totalHeader = "";
            }

            return <div className="row header">
                <div className="col-7 col-lg-6 col-hd">
                    Item
                </div>
                <div className="col-2 col-lg-2 col-hd text-center">
                    Qty
                </div>
                <div className="col-3 col-lg-2 col-hd text-center">
                    {priceHeader}   
                </div>
                <div className="d-none d-lg-block col-lg-2 col-hd cart-total-header text-center">
                    {totalHeader}
                </div>
            </div>
        }
    }

    renderFreightCost() {
        if (!isNullOrUndefined(this.state.cart.freightCost)) {
            return <tr>
                <td className="pr-3">Delivery:</td>
                <td>{formatMoney(this.state.cart.freightCost)}</td>
            </tr>;
        }
    }

    renderSurchargeCost() {
        if (!isNullOrUndefined(this.state.cart.surchargeCost)) {
            if (this.state.cart.surchargeCost === 0) {
                return null;
            }

            return <tr>
                <td className="pr-3">
                    <a href="/fuel-surcharge/">Fuel Levy</a> <i className="icon icon-info" data-tip='Temporary levy for high fuel prices, click to learn more'></i>   <ReactTooltip />

                    :</td>
                <td>{formatMoney(this.state.cart.surchargeCost)}</td>
                   </tr>;
        }
    }

    renderCreditCardSurchargeCost() {
        if (!isNullOrUndefined(this.state.cart.surchargeCost)) {
            if (this.state.cart.creditCardSurchargeCost === 0) {
                return null;
            }

            return <tr>
                <td className="pr-3" style={{ "letter-spacing": "-0.5px" }}>
                    Credit Card Surcharge <i className="icon icon-info" data-tip='1.75% surcharge for credit card payment'></i> <ReactTooltip />
                    :</td>
                <td>{formatMoney(this.state.cart.creditCardSurchargeCost)}</td>
            </tr>;
        }
    }

    renderTotal() {
        if (this.state.cart.lines.length > 0) {

            if (this.props.hidePrices) {
                return <div></div>;
            }

            return (
                <div className="row cart-total-group">
                    <div className="col-12">
                        <div className="d-flex flex-column align-items-end text-right">

                            <table>
                                <tbody>
                                    <tr>
                                        <td className="pr-3">Sub total:</td>
                                        <td>{formatMoney(this.state.cart.subTotal)}</td>
                                    </tr>
                                    {this.renderFreightCost()}
                                    <tr>
                                        <td className="pr-3"></td>
                                        <td><hr /></td>
                                    </tr>
                                    {this.renderSurchargeCost()}
                                    {this.renderCreditCardSurchargeCost()}
                                 

                                    <tr>
                                        <td className="pr-3">GST:</td>
                                        <td>{formatMoney(this.state.cart.totalTax)}</td>
                                    </tr>
                                    <tr>
                                        <td className="pr-3">Total EX. GST:</td>
                                        <td>{formatMoney(this.state.cart.totalPrice)}</td>
                                    </tr>
                                    <tr>
                                        <td className="pr-3">Total INC. GST:</td>
                                        <td><strong>{formatMoney(this.state.cart.totalPrice + this.state.cart.totalTax)
                                        }</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>);
        }
    }

    renderRejectButton() {
        if (this.state.cart.hasCompleted) {
            return null;
        }

        if (!this.state.cart.canApprove) {
            return null;
        }

        return <button className={"btn btn-danger btn-lg btn-edit-after-approval float-left "} onClick={this.openRejectModal.bind(this)} >Reject</button>;
    }

    renderCheckoutButton() {
        if (this.props.disableOnlineOrdering) {
            return null;
        }

        if (this.state.cart.hasCompleted) {
            return null;
        }

        if (this.state.cart.id == 0) {
            return <a href="/register/?redirect=/cart/new/" className={"checkout-btn btn btn-primary btn-lg  float-right "}>Register and Checkout</a>;
        }

        if (!this.state.cart.canEdit && !this.state.cart.canApprove) {
            return null;
        }
        var btnClass = 'changes';
        var disabled = false;

        var buttonText = "Checkout";
        var buttonTextApprove = "Approve";
        var buttonTextEdit = "Edit";
        var btnClassSendForEdit = 'changes';

        if (this.state.isSaving) {
            disabled = true;
            buttonText = "Updating";
            btnClass = 'saving';
        }

        if (this.state.isCheckingOut) {
            disabled = true;
            buttonText = "Checkout";
            btnClass = 'saving';
        }

        if (this.state.isApproving) {
            disabled = true;
            buttonTextApprove = "Approving";
        }

        if (this.state.isSendingForEdit) {
            btnClassSendForEdit = 'saving';
            disabled = true;
        }        

        if (this.state.cart.lines.length === 0) {
            disabled = true;
        }
        if (this.state.cart.canEdit) {
            return <button href="#" className={"checkout-btn btn btn-primary btn-lg  float-right " + btnClass} disabled={disabled} onClick={this.checkout.bind(this)}>{buttonText}</button>;
        } else if (this.state.cart.canApprove) {
            if (this.state.cart.requiresFurtherApproval) {
                return [
                    <button href="#" className={"btn btn-primary btn-lg  float-right " + btnClass} disabled={disabled} onClick={this.checkout.bind(this)}>Submit</button>,
                    <button href="#" className={"btn btn-secondary btn-lg btn-edit-after-approval float-right " + btnClassSendForEdit} disabled={disabled} onClick={this.sendForEdit.bind(this)}>Edit</button>
                ];
            }

            // Austral Account
            if ([44366].includes(this.props.initialCart.accountId)) {
                return [
                    <button href="#" className={"checkout-btn btn btn-primary btn-lg  float-right " + btnClass} disabled={disabled} onClick={this.checkout.bind(this)}>{buttonText}</button>,
                    <button href="#" className={"btn btn-secondary btn-lg btn-edit-after-approval float-right " + btnClassSendForEdit} disabled={disabled} onClick={this.sendForEdit.bind(this)}>Edit</button>
                ];
            }

            return [
                <button href="#" className={"btn btn-primary btn-lg  float-right " + btnClass} disabled={disabled} onClick={this.approve.bind(this)}>Approve and order</button>,
                <button href="#" className={"btn btn-secondary btn-lg btn-edit-after-approval float-right " + btnClassSendForEdit} disabled={disabled} onClick={this.sendForEdit.bind(this)}>Edit</button>
            ];
        }
    }

    updatePurchaseOrderNumber(ev) {
        var cart = this.state.cart;
        if (ev.target.value.length <= 20) {
           cart.purchaseOrderNumber = ev.target.value;
            this.setState({ cart: cart }, this.updateServerWithStateTimeout()); 
        }
    }

    handleRejectReasonChange(event) {
        this.setState({ rejectReason: event.target.value });
        
    }

    renderDoRejectButton() {
        var btnText = 'Reject Order';
        var btnClass = 'changes';

        if (this.state.isRejectSaving) {
            btnText = 'Rejecting';
            btnClass = 'saving';
        }

        return <button className={"btn btn-danger float-right " + btnClass} disabled={this.state.isRejectSaving} onClick={this.rejectOrder.bind(this)}>{btnText}</button>;
    }

    renderRejectPopover() {
        return <ReactModal isOpen={this.state.rejectModalOpen} onRequestClose={this.closeRejectModal.bind(this)} portalClassName="modal-portal" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                   <div className="modal-content">
                       <div className="bd p-15">
                           <h5 className="m-0">Reject Order</h5>
                       </div>
                        <div className="modal-body">

                            <div className="mb-2">
                                <label>Reason</label>
                        <textarea className="form-control w-100" onChange={this.handleRejectReasonChange.bind(this)} value={this.state.rejectReason}></textarea>
                            </div>

                            {this.renderDoRejectButton()}
                        </div>
                       <button onClick={this.closeRejectModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                   </div>
               </ReactModal>;
    }



    render()
    {
        var readOnly = false;
        if (this.state.cart.requiresApproval && !this.canApprove()) {
            readOnly = true;
        }
        
        var renderNotSubmittedStatus = <li className="active"><span>Not Submitted</span></li>;
        var renderAwaitingApprovalStatus = null;
        if (this.state.cart.requiresApproval == true) {
            renderAwaitingApprovalStatus = <li><span>Awaiting Approval</span></li>;
            if (this.state.cart.orderApproval.filter(x => !x.isComplete).length > 0) {
                renderNotSubmittedStatus = <li className="complete"><span>Not Submitted</span></li>;
                renderAwaitingApprovalStatus = <li className="active"><span>Awaiting Approval</span></li>;
            }
        }        
        var renderPurchaseOrderNumberTextField = null;
        var renderPurchaseOrderNumberLabel = null;
        if (this.state.cart.canEdit && this.state.cart.canApprove) {
            renderPurchaseOrderNumberLabel = <h6>Purchase Order Number:</h6>;
            renderPurchaseOrderNumberTextField = <input type="text" className="form-control" value={this.state.cart.purchaseOrderNumber} onChange={this.updatePurchaseOrderNumber.bind(this)} readOnly={!this.state.cart.canEdit} />;
        }


        var showBudget = true;
        if (this.props.hideBudget) {
            showBudget = false;
        }

        var orderStatus = null;
        var className = "col-lg-12";
        if (this.state.cart.id != 0) {
            className = "col-lg-9";
            orderStatus = <div className="col-lg-3">
                              <div className="d-none d-lg-block">
                                  <strong>Order Status</strong>
                                  <ul className="order-status">

                                      {renderNotSubmittedStatus}
                                      {renderAwaitingApprovalStatus}
                                      <li><span>Processing</span></li>
                                      <li><span>{this.state.orderStatus}</span></li>
                                      <li><span>Complete </span></li>
                                  </ul>
                              </div>
                              <strong>Delivery Option</strong>
                              <OrderDeliveryOption 
                                  cart={this.state.cart}
                                  onChange={this.setDeliveryOption.bind(this)}
                                  readOnly={!this.state.cart.canEdit || (this.props.currentUser && this.props.currentUser.isTemplaCustomer && !isNullOrUndefined(this.props.punchoutData))}
                                  oneColumn={true}
                                  showBudget={showBudget}
                                  hidePrices={this.props.hidePrices} />
                              {renderPurchaseOrderNumberLabel}
                              {renderPurchaseOrderNumberTextField}
                          </div>;
        }

        if (this.props.isItemReplacement) {
            return <div> <div className={"col-lg-12"}>
                <div className="list-group">
                    {this.renderHeader()}
                    {this.renderNoItemMessage()}
                    {this.state.cart.lines.map((lineData) =>
                        <CartLine lineData={lineData} cart={this.state.cart}
                            updateQuantity={this.updateQuantity.bind(this)}
                            removeItem={this.removeItem.bind(this)}
                            updateRechargeable={this.updateRechargeable.bind(this)}
                            updateStockcode={this.updateStockcode.bind(this)}
                            replacePartial={this.replacePartial.bind(this)}
                            isSaving={this.state.isSaving}
                            hidePrices={this.props.hidePrices}
                            isItemReplacement={this.props.isItemReplacement}
                            updateDontReplaceCollection={this.updateDontReplaceCollection.bind(this)}
                            dontReplaceCollection={this.props.dontReplaceCollection}
                            disableItemReplacement={this.props.disableItemReplacement}
                            selectedItem={this.state.selectedItem}
                            member={this.props.member}
                        />)}
                </div>             
            </div>                
            </div>
        }
        var cartItems = this.state.cart.lines.map((item, index) => {
            return {
                'item_name': item.description,       // Name or ID is required.
                'item_id': item.stockcode,
                'price': item.unitPrice,
'quantity': item.quantity,
            }
        });
   
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "view_cart",
            ecommerce: {
                currency: "AUD",
                value: this.state.cart.totalPrice,
                items: cartItems
            }
        });
        return <div>
            
            {this.renderRejectPopover()}
            <div className="row">
                {orderStatus}
                <div className={className}>
                    <div className="list-group">
                        {this.renderForApprovalMessage()}
                        {this.renderCompleteMessage()}
                        {this.renderHeader()}
                        {this.renderNoItemMessage()} 
                       
                        {this.state.cart.lines.map((lineData) => <CartLine lineData={lineData}
                            cart={this.state.cart}
                            updateQuantity={this.updateQuantity.bind(this)}
                            removeItem={this.removeItem.bind(this)}
                            updateRechargeable={this.updateRechargeable.bind(this)}
                            updateStockcode={this.updateStockcode.bind(this)}
                            replacePartial={this.replacePartial.bind(this)}
                            isSaving={this.state.isSaving}
                            hidePrices={this.props.hidePrices}
                            disableItemReplacement={this.props.disableItemReplacement}
                            isItemReplacement={this.props.isItemReplacement}
                            member={this.props.member}
                        />)}


                        {this.renderTotal(this)}
                    </div>
                </div>
            </div>
            {this.renderRejectButton()}
            {this.renderCheckoutButton()}
        </div >;
    }
}
